import './FractalFrame.css'
export type FractalFrameProps = {
    bgColor?: string;
    beforeColor?: string;
    afterColor?: string;
    children: any;
}
export function FractalFrame(props: FractalFrameProps){
    const styleVars = Object.fromEntries(
        Object.entries(props)
          .filter(([key, value]) => key !== 'children' && value !== undefined)
          .map(([key, value]) => [`--${key}`, value])
      );
    return (
        <div className="fractal-frame" style={styleVars}>
            {props.children}
        </div>
    )
}